module.exports = __webpack_public_path__ + "static/media/blogThumbnail3.95b74f36.jpg";